import { Helmet } from 'react-helmet-async';
import PageBanner from '@components/Common/PageBanner';
import RightClickProtection from '@components/Common/RightClickProtection';
import './SketchPad.css';

const SketchPad = () => {
    const sketches = [
        { id: 1, title: 'Conceptual Villa Sketch', image: '/images/sketch1.jpg' },
        { id: 2, title: 'Modern Residence', image: '/images/sketch2.jpg' },
        { id: 3, title: 'Office Building Design', image: '/images/sketch3.jpg' },
        { id: 4, title: 'Interior Perspective', image: '/images/sketch4.jpg' }
    ];

    return (
        <RightClickProtection>
            <Helmet>
                <title>Architect's Sketch Pad - AT Architects</title>
                <meta name="description" content="Conceptual drawings and hand sketches from our design process." />
            </Helmet>

            <PageBanner
                title="Architect's Sketch Pad"
                subtitle="Conceptual drawings and hand sketches"
                backgroundImage="/images/sketch-banner.jpg"
            />

            <section className="sketch-section">
                <div className="sketch-container">
                    <div className="sketch-grid">
                        {sketches.map(sketch => (
                            <div key={sketch.id} className="sketch-item">
                                <div className="sketch-image-wrapper">
                                    <img src={sketch.image} alt={sketch.title} />
                                </div>
                                <h3>{sketch.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </RightClickProtection>
    );
};

export default SketchPad;
